import { ReactElement } from 'react';

import games from './data';

import GamesList from '../Games';

export default function LiveCasinoGames(): ReactElement {
  return <GamesList games={games} />;
}
